import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import client from './apolloClient';
import App from './App';
import ErrorBoundary from './components/resilience/ErrorBoundary';

// In PRODUCTION builds, silence developer console.log/debug noise entirely
// (DDS patch traces, [buildLineup], "Swap type", etc.). Real problems still
// surface via console.warn/error; devs see everything via `npm start`.
// In dev, keep filtering the per-JSONata `Expr: "...", Result: ...` spam from
// @aelive/data-binding-library which slows caption rendering noticeably.
const EXPR_LOG_PATTERN = /^Expr: ".*", Result: /;
const _origLog = console.log;
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
} else {
  console.log = (...args) => {
    if (typeof args[0] === 'string' && EXPR_LOG_PATTERN.test(args[0])) return;
    _origLog.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Root boundary: last resort. A render-time throw anywhere below used to
        unmount the whole tree and leave a TXLive operator with a white screen
        mid-match. */}
    <ErrorBoundary variant="root">
      <ApolloProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
